import { render, staticRenderFns } from "./deviceLicense.vue?vue&type=template&id=38fc5e3a&"
import script from "./deviceLicense.vue?vue&type=script&lang=js&"
export * from "./deviceLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports